import { GET_ALL_USERS,CREATE_USER,UPDATE_USER,DELETE_USER } from "../actions/users";
import { API_BASE_URL, GET_ALL_USERS_URL,CREATE_USER_URL,UPDATE_USER_URL,DELETE_USER_URL} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [GET_ALL_USERS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + GET_ALL_USERS_URL,
            method: "GET",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.get_access_token }
        });
    },
    [CREATE_USER]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CREATE_USER_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.get_access_token }
        });
    },
    [UPDATE_USER]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + UPDATE_USER_URL + payload.id,
            method: "PUT",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.get_access_token }
        });
    },
    [DELETE_USER]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + DELETE_USER_URL + payload,
            method: "DELETE",
            // data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.get_access_token }
        });
    },
};
export default {
    mutations,
    actions,
    getters,
    state
};